import { fmtMoney, priceUnit } from '../../data/format';

/**
 * What a unit price is per, as shown on screen: '100 ft' for wire (the data
 * keeps wire in C), '10 ft length' for conduit, otherwise the unit itself.
 */
export function priceUnitLabel(unit: string): string {
  return unit === 'stick' ? '10 ft length' : priceUnit(unit);
}

/** Cents for unit prices ('$424.36', '$88.70'), whole dollars from $1,000. */
export function fmtUnitPrice(price: number): string {
  return price >= 1000 ? fmtMoney(price) : fmtMoney(price, { cents: true });
}

/** '$424.36 / 100 ft', '$88.70 / fixture'. For compact cells. */
export function fmtPerUnit(price: number, unit: string): string {
  return `${fmtUnitPrice(price)} / ${priceUnitLabel(unit)}`;
}

/** '$424.36 per 100 ft', '$88.70 per fixture', '$5,500 each'. For sentences. */
export function fmtPricePerUnit(price: number, unit: string): string {
  return unit === 'each'
    ? `${fmtUnitPrice(price)} each`
    : `${fmtUnitPrice(price)} per ${priceUnitLabel(unit)}`;
}

/** 'per 100 ft', 'per fixture', 'each'. Reads after a price in a sentence. */
export function perUnitPhrase(unit: string): string {
  return unit === 'each' ? 'each' : `per ${priceUnitLabel(unit)}`;
}

/** Compact volume for chart axes: 73,840 becomes '73.8K'. */
export function fmtVolumeCompact(value: number): string {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(2)}M`;
  if (value >= 10_000) return `${(value / 1_000).toFixed(0)}K`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(1)}K`;
  return String(Math.round(value));
}

/** One-decimal millions for headline savings ('$0.9M'). */
export function fmtMillions(value: number): string {
  return `$${(value / 1_000_000).toFixed(1)}M`;
}
